import React, { useEffect, useState } from "react";
import "./Product_Info.css";
import { Form } from "react-bootstrap";
import {
  faAngleDown,
  faAngleRight,
  faCircleXmark,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import InnerImageZoom from 'react-inner-image-zoom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Increment_decrement_btn_holder from "../../common-components/common-btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useForm } from "react-hook-form";
import Gray_Outline_Button from "../../common-components/common-btn/gray_outline_btn/Gray_Outline_Button";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartLens,
  deleteSingleCart,
  getAllCart,
} from "../../../features/cart/cartSlice";
import {
  CouponApplyed,
  OrderCalculation,
} from "../../../features/order/orderSlice";
import useIsMobile from "./useIsMobile"; // 👈 new hook
import Success_Modal from "../../common-components/common-modals/success_modal/Success_Modal";
import View_All_Coupon_Code from "../../common-components/common-modals/view_All_Coupon_Code/View_All_Coupon_Code";
import Red_Outline_Btn from "../../common-components/common-btn/red_outline_btn/Red_Outline_Btn";

const Product_Info = ({
  carts,
  setCouponData,
  CouponData,
  setSelectedIds,
  selectedIds,
  orderSumary,
}) => {
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [openStates, setOpenStates] = useState({});

  const [modalShow, setModalShow] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const toggleRow = (id) => {
    setOpenStates((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const DeleteCartProduct = async (id, product_id, variant_id) => {
    try {
      const data = { id, isSignin: isSignIn, product_id, variant_id };
      const res = await dispatch(deleteSingleCart(data));
      if (res.meta?.requestStatus === "fulfilled") {
        setCouponData();
        setValue("code", "");
        dispatch(getAllCart(isSignIn));
      } else {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const DeleteCartLeans = async (id, product_id, variant_id) => {
    try {
      const data = { id, isSignin: isSignIn, product_id, variant_id };
      const res = await dispatch(deleteCartLens(data));
      if (res.meta?.requestStatus === "fulfilled") {
        setCouponData();
        setValue("code", "");
        dispatch(getAllCart(isSignIn));
      } else {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleCouponReset = () => {
    setCouponData();
    setValue("code", "");
  };

  const onSubmit = async (data) => {
    // data.amount = orderSumary?.order_summary?.total_amount;
    data.amount = orderSumary?.order_summary?.total_mrp;
    const res = await dispatch(CouponApplyed(data));
    if (res?.payload?.data) {
      setCouponData(res?.payload?.data);
      setShowModal(true);
    }
    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload?.errors,
      });
    }
  };

  const isMobile = useIsMobile();

  const allIds = carts?.data?.data?.map((item) => item?.id) || [];

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
    setCouponData();
    setValue("code", "");
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(allIds);
      setCouponData();
      setValue("code", "");
    } else {
      setSelectedIds([]);
      setCouponData();
      setValue("code", "");
    }

    // handleCouponReset()
  };
  const [Error, setErrors] = useState("");

  const [qty, setQty] = useState({});

  const handleAdd = (id) => {
    setQty({ ...qty, [id]: 1 });
  };

  const handleIncrease = (id) => {
    setQty({ ...qty, [id]: qty[id] + 1 });
  };

  const handleDecrease = (id) => {
    if (qty[id] === 1) {
      // return to Add +
      const updated = { ...qty };
      delete updated[id];
      setQty(updated);
    } else {
      setQty({ ...qty, [id]: qty[id] - 1 });
    }
  };

  const [openProduct, setOpenProduct] = useState({});
  const [openLens, setOpenLens] = useState({});
  const [openAddon, setOpenAddon] = useState({});

  const toggleProduct = (id) => {
    setOpenProduct((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleLens = (id) => {
    setOpenLens((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleAddon = (id) => {
    setOpenAddon((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="Product_Info">
      <div className="container">
        {isMobile ? (
          <div className="mobile_view_table_holder">
            <div className="select_all_div">
              <Form.Check
                type="checkbox"
                checked={
                  selectedIds.length === allIds.length && allIds.length > 0
                }
                onChange={handleSelectAll}
              />
            </div>

            {carts?.data?.data?.map((item, index) => {
              const isOpen = openStates[item.id] || false;

              return (
                <div className="mobile_addon_card_section_holder">
                  <div className="mobile_product_card" key={index}>
                    <div className="row">
                      <div className="col-5">
                        <div className="select_div">
                          <Form.Check
                            type="checkbox"
                            checked={selectedIds.includes(item?.id)}
                            onChange={() => handleCheckboxChange(item?.id)}
                          />
                        </div>
                        <div className="img_holder">
                          <img
                            src={
                              process.env.REACT_APP_IMAGE_URL +
                              item?.Product?.image
                            }
                            alt={item?.Product?.name}
                            className="prod_img"
                          />

                          {/* <ReactImageMagnify
                            {...{
                              smallImage: {
                                alt: item?.Product?.name,
                                isFluidWidth: true,
                                className: "product_img",
                                src:
                                  process.env.REACT_APP_IMAGE_URL +
                                  item?.Product?.image,
                              },

                              largeImage: {
                                src:
                                  process.env.REACT_APP_IMAGE_URL +
                                  item?.Product?.image,
                                width: 1200,
                                height: 1200,
                              },

                              // 👉 show magnified image over the table
                              enlargedImagePosition: "over",

                              // 👉 fix container & ensure it goes ABOVE everything
                              enlargedImageContainerStyle: {
                                zIndex: 99999999,
                                background: "white",
                                border: "1px solid #ddd",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                              },

                              // optional but recommended
                              // enlargedImageContainerDimensions: {
                              //   width: "200%",
                              //   height: "200%",
                              // },
                            }}
                          /> */}
                        </div>
                      </div>
                      <div className="col-7 ps-0">
                        <div className="descn_holder common_table ">
                          <div className="all_btns_holder">
                            <div className="Quantity_tr_holder">
                              {/* <Increment_decrement_btn_holder
                            item={item}
                            setErrors={setErrors}
                            Error={Error}
                          /> */}
                              {Error}
                              <FontAwesomeIcon
                                onClick={() =>
                                  DeleteCartProduct(item?.id, item?.product_id)
                                }
                                className="trash_icon"
                                icon={faTrashCan}
                              />
                            </div>
                          </div>
                          <div className="product_details">
                            <div className="bold_text product_title">
                              {item?.Product?.name}
                            </div>

                            <div className="details_holder">
                              {/* Show Details Button */}
                              <h6
                                className="show_deatils_text"
                                onClick={() => toggleProduct(item.id)}
                                style={{ cursor: "pointer" }}
                              >
                                Show Product Details{" "}
                                <FontAwesomeIcon
                                  icon={faAngleDown}
                                  className={
                                    openProduct[item.id] ? "rotate_icon" : ""
                                  }
                                />
                              </h6>

                              {/* Collapsible Content */}
                              <div
                                className={`details_wrapper ${
                                  openProduct[item.id] ? "open" : "closed"
                                }`}
                              >
                                {/* Add-On Details */}
                                <div className="product_details mb-3">
                                  <div className="bold_text">
                                    Product Details
                                  </div>
                                  <p className="normal_text">
                                    <b>Frame Type –</b>{" "}
                                    {item?.Product?.Frame_Type?.name || "NA"}
                                  </p>
                                  <p className="normal_text">
                                    <b>Size –</b> {item?.Product?.size || "NA"}
                                  </p>
                                  <p className="normal_text">
                                    <b>Material –</b>{" "}
                                    {item?.Product?.Material?.name || "NA"}
                                  </p>
                                  <p className="normal_text">
                                    <b>Colour – </b>
                                    {item?.Product?.Colour?.name || "NA"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {item?.Prescription?.Lense && (
                    <div className="addon_section_holder">
                      <div className="mobile_product_card" key={index}>
                        <div className="row">
                          <div className="col-5">
                            <div className="img_holder">
                              {/* <img
                                src={
                                  process.env.REACT_APP_IMAGE_URL +
                                  item?.Prescription?.Lense?.image
                                }
                                alt={item?.Product?.name}
                                className="prod_img"
                              /> */}

                              <img
                                src={"/assets/images/lanse/lense_img_1.png"}
                                alt="lense"
                                className="product_img"
                              />
                            </div>
                          </div>
                          <div className="col-7 ps-0">
                            <FontAwesomeIcon
                              className="trash_icon"
                              icon={faTrashCan}
                              onClick={() =>
                                DeleteCartLeans(item?.Prescription?.id, item?.product_id)
                              }
                            />
                            <div className="descn_holder common_table ">
                              <div className="product_details">
                                <div className="bold_text">
                                  {item?.Product?.name}
                                </div>

                                <div className="details_holder">
                                  {/* Show Details Button */}
                                  <h6
                                    className="show_deatils_text"
                                    onClick={() => toggleLens(item.id)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Show Lens Details{" "}
                                    <FontAwesomeIcon
                                      icon={faAngleDown}
                                      className={
                                        openLens[item.id] ? "rotate_icon" : ""
                                      }
                                    />
                                  </h6>

                                  {/* Collapsible Content */}
                                  <div
                                    className={`details_wrapper ${
                                      openLens[item.id] ? "open" : "closed"
                                    }`}
                                  >
                                    {/* Add-On Details */}
                                    <div className="product_details mb-3">
                                      <div className="bold_text">
                                        Lens Details
                                      </div>
                                      <p className="normal_text">
                                        Lens Type –{" "}
                                        {
                                          item?.Prescription?.Lense?.LensType
                                            ?.name
                                        }
                                      </p>
                                      <p className="normal_text">
                                        Brand –{" "}
                                        {item?.Prescription?.Lense?.Brand
                                          ?.name || "NA"}
                                      </p>
                                      <p className="normal_text">
                                        Material –{" "}
                                        {item?.Prescription?.Lense?.Material
                                          ?.name || "NA"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {item?.Prescription?.Addon && (
                        <div className="mobile_product_card" key={index}>
                          <div className="row">
                            <div className="col-5">
                              <div className="img_holder">
                                {/* <img
                                src={
                                  process.env.REACT_APP_IMAGE_URL +
                                  item?.Prescription?.Addon?.image
                                }
                                alt={item?.Product?.name}
                                className="prod_img"
                              /> */}
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_URL +
                                    item?.Prescription?.Addon?.image
                                  }
                                  alt="lense"
                                  className="product_img"
                                />
                              </div>
                            </div>
                            <div className="col-7 ps-0">
                              {/* <FontAwesomeIcon
                                className="trash_icon"
                                icon={faTrashCan}
                              /> */}
                              <div className="descn_holder common_table ">
                                <div className="product_details">
                                  <div className="bold_text">
                                    {item?.Product?.name}
                                  </div>

                                  <div className="details_holder">
                                    {/* Show Details Button */}
                                    <h6
                                      className="show_deatils_text"
                                      onClick={() => toggleAddon(item.id)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Show Add On Details{" "}
                                      {/* <FontAwesomeIcon
                                        icon={faAngleDown}
                                        className={
                                          openAddon[item.id]
                                            ? "rotate_icon"
                                            : ""
                                        }
                                      /> */}
                                      <FontAwesomeIcon
                                        icon={faAngleDown}
                                        className={
                                          openAddon[item.id]
                                            ? "rotate_icon"
                                            : ""
                                        }
                                      />
                                    </h6>

                                    {/* Collapsible Content */}
                                    <div
                                      // className={`details_wrapper ${
                                      //   openAddon[item.id] ? "open" : "closed"
                                      // }`}
                                      className={`details_wrapper ${
                                        openAddon[item.id] ? "open" : "closed"
                                      }`}
                                    >
                                      {/* Add-On Details */}
                                      <div className="product_details mb-3">
                                        <div className="bold_text">
                                          Add Ons Details
                                        </div>
                                        <p className="normal_text">
                                          Name –{" "}
                                          {item?.Prescription?.Addon?.name ||
                                            "NA"}
                                        </p>
                                        <p className="normal_text">
                                          Price –{" "}
                                          {item?.Prescription?.Addon?.price ||
                                            "NA"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            <Form>
              <div className="footer_div mt-3">
                <h6 style={{ fontSize: "11px", marginBottom: "11px" }}>
                  Best Coupons
                </h6>

                <p
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "11px",
                    marginBottom: "11px",
                  }}
                  onClick={() => setModalShow(true)}
                >
                  View All Coupon <FontAwesomeIcon icon={faAngleRight} />
                </p>
              </div>

              <div className="footer_div">
                <Form.Group className="input_group">
                  <Form.Control
                    type="text"
                    placeholder="Enter your coupon code"
                    {...register("code", { required: "Code is required" })}
                  />
                  {errors?.code && (
                    <sup className="text-danger">{errors?.code?.message}</sup>
                  )}
                </Form.Group>
                <div className="btn_holder">
                  <Gray_Outline_Button
                    type="button"
                    btnText={"Apply"}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </Form>
          </div>
        ) : (
          <div className="desktop_view">
            <div className="common_table_container theme_bg">
              <div className="table-responsive">
                <table className="common_table table">
                  <thead>
                    <tr>
                      <th>
                        <Form.Check
                          type="checkbox"
                          checked={
                            selectedIds.length === allIds.length &&
                            allIds.length > 0
                          }
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th> Product Info</th>
                      <th>Price</th>
                      <th>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    {carts?.data?.data.map((item, idx) => {
                      const isOpen = openStates[item.id] || false;

                      return (
                        <tr key={idx}>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={selectedIds.includes(item?.id)}
                              onChange={() => handleCheckboxChange(item?.id)}
                            />
                          </td>

                          <td>
                            <div className="product_info_cell">
                              <div className="product_img_holder">
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_URL +
                                    item?.Product?.image
                                  }
                                  alt={item?.Product?.name}
                                  className="product_img"
                                />

                                {/* <ReactImageMagnify
                                  {...{
                                    smallImage: {
                                      alt: item?.Product?.name,
                                      isFluidWidth: true,
                                      className: "product_img",
                                      src:
                                        process.env.REACT_APP_IMAGE_URL +
                                        item?.Product?.image,
                                    },

                                    largeImage: {
                                      src:
                                        process.env.REACT_APP_IMAGE_URL +
                                        item?.Product?.image,
                                      width: 1200,
                                      height: 1200,
                                    },

                                    // 👉 show magnified image over the table
                                    enlargedImagePosition: "over",

                                    // 👉 fix container & ensure it goes ABOVE everything
                                    enlargedImageContainerStyle: {
                                      zIndex: 99999999,
                                      background: "white",
                                      border: "1px solid #ddd",
                                      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    },

                                    // optional but recommended
                                    // enlargedImageContainerDimensions: {
                                    //   width: "200%",
                                    //   height: "200%",
                                    // },
                                  }}
                                /> */}
                              </div>

                              <div className="product_details">
                                <div className="bold_text">
                                  {item?.Product?.name}
                                </div>
                                <div className="details_holder">
                                  {/* Show Details Button */}
                                  <h6
                                    className="show_deatils_text"
                                    onClick={() => toggleProduct(item.id)}
                                  >
                                    Show Product Details{" "}
                                    <FontAwesomeIcon
                                      icon={faAngleDown}
                                      className={
                                        openProduct[item.id]
                                          ? "rotate_icon"
                                          : ""
                                      }
                                    />
                                  </h6>

                                  <div
                                    className={`details_wrapper ${
                                      openProduct[item.id] ? "open" : "closed"
                                    }`}
                                  >
                                    {/* Add-On Details */}
                                    <div className="product_details mb-3">
                                      <div className="bold_text">
                                        Product Details
                                      </div>
                                      {item?.Product?.Frame_Type?.name && (
                                        <p className="normal_text">
                                          Frame Type –{" "}
                                          {item?.Product?.Frame_Type?.name ||
                                            "NA"}
                                        </p>
                                      )}
                                      {item?.Product?.Colour?.name && (
                                        <p className="normal_text">
                                          Colour –{" "}
                                          {item?.Product?.Colour?.name || "NA"}
                                        </p>
                                      )}
                                      {item?.Product?.Material?.name && (
                                        <p className="normal_text">
                                          Material –{" "}
                                          {item?.Product?.Material?.name ||
                                            "NA"}
                                        </p>
                                      )}
                                      {item?.Product?.size && (
                                        <p className="normal_text">
                                          Size – {item?.Product?.size || "NA"}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {item?.Prescription?.Lense && (
                              <div className="addon_section_holder">
                                <div className="product_info_cell">
                                  <div className="product_img_holder">
                                    {/* <img
                                      src={
                                        process.env.REACT_APP_IMAGE_URL +
                                        item?.Prescription?.Lense?.image
                                      }
                                      alt={item?.Prescription?.Lense?.name}
                                      className="product_img"
                                    /> */}

                                    <img
                                      src={
                                        "/assets/images/lanse/lense_img_1.png"
                                      }
                                      alt="lense"
                                      className="product_img"
                                    />
                                  </div>

                                  <div className="product_details">
                                    <div className="bold_text">
                                      {item?.Prescription?.Lense?.name}
                                    </div>

                                    <div className="details_holder">
                                      {/* Show Details Button */}
                                      <h6
                                        className="show_deatils_text"
                                        onClick={() => toggleLens(item.id)}
                                      >
                                        Show Lens Details{" "}
                                        <FontAwesomeIcon
                                          icon={faAngleDown}
                                          className={
                                            openLens[item.id]
                                              ? "rotate_icon"
                                              : ""
                                          }
                                        />
                                      </h6>

                                      <div
                                        className={`details_wrapper ${
                                          openLens[item.id] ? "open" : "closed"
                                        }`}
                                      >
                                        {/* Add-On Details */}
                                        <div className="product_details mb-3">
                                          <div className="bold_text">
                                            Details
                                          </div>
                                          <p className="normal_text">
                                            Type –{" "}
                                            {item?.Prescription?.Lense?.LensType
                                              ?.name || "NA"}
                                          </p>
                                          <p className="normal_text">
                                            Brand –{" "}
                                            {item?.Prescription?.Lense?.Brand
                                              ?.name || "NA"}
                                          </p>
                                          <p className="normal_text">
                                            Material –{" "}
                                            {item?.Prescription?.Lense?.Material
                                              ?.name || "NA"}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <FontAwesomeIcon
                                    className="trash_icon"
                                    icon={faTrashCan}
                                    onClick={() =>
                                      DeleteCartLeans(
                                        item?.Prescription?.id,
                                        item?.product_id,
                                      )
                                    }
                                  />
                                </div>
                                {item?.Prescription?.Addon && (
                                  <div className="product_info_cell">
                                    <div className="product_img_holder">
                                      <img
                                        src={
                                          process.env.REACT_APP_IMAGE_URL +
                                          item?.Prescription?.Addon?.image
                                        }
                                        alt={item?.Product?.name}
                                        className="product_img"
                                      />
                                    </div>

                                    <div className="product_details">
                                      {/* <div className="bold_text">
                                        {item?.Product?.name}
                                      </div> */}

                                      <div className="details_holder">
                                        {/* Show Details Button */}
                                        <h6
                                          className="show_deatils_text"
                                          onClick={() => toggleAddon(item.id)}
                                        >
                                          Show Add On Details{" "}
                                          <FontAwesomeIcon
                                            icon={faAngleDown}
                                            className={
                                              openAddon[item.id]
                                                ? "rotate_icon"
                                                : ""
                                            }
                                          />
                                        </h6>

                                        <div
                                          className={`details_wrapper ${
                                            openAddon[item.id]
                                              ? "open"
                                              : "closed"
                                          }`}
                                        >
                                          {/* Add-On Details */}
                                          <div className="product_details mb-3">
                                            <div className="bold_text">
                                              Add-On Details
                                            </div>
                                            <p className="normal_text">
                                              Name –{" "}
                                              {item?.Prescription?.Addon
                                                ?.name || "NA"}
                                            </p>
                                            <p className="normal_text">
                                              Price –{" "}
                                              {item?.Prescription?.Addon
                                                ?.price || "NA"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </td>

                          <td>
                            <span className="bold_text">
                              ₹{item?.Product?.price}
                            </span>
                          </td>

                          <td className="action_div">
                            <div
                              className="icon_holder"
                              onClick={() =>
                                DeleteCartProduct(item?.id, item?.product_id)
                              }
                            >
                              <FontAwesomeIcon
                                icon={faCircleXmark}
                                className="delete_icon"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <Form>
              <div className="footer_div">
                <h6 style={{ fontSize: "15px", marginBottom: "0px" }}>
                  Best Coupons
                </h6>

                <p
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "12px",
                    marginBottom: "0px",
                  }}
                  onClick={() => setModalShow(true)}
                >
                  View All Coupon <FontAwesomeIcon icon={faAngleRight} />
                </p>
              </div>

              <div className="footer_div">
                <Form.Group className="input_group">
                  <Form.Control
                    type="text"
                    placeholder="Enter your coupon code"
                    {...register("code", { required: "Code is required" })}
                  />
                  {errors?.code && (
                    <sup className="text-danger">{errors?.code?.message}</sup>
                  )}
                </Form.Group>
                {CouponData ? (
                  <div className="btn_holder">
                    <Red_Outline_Btn
                      type="button"
                      btnText={"Remove"}
                      onClick={handleCouponReset}
                    />
                  </div>
                ) : (
                  <div className="btn_holder">
                    <Gray_Outline_Button
                      type="button"
                      btnText={"Apply"}
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                )}
              </div>
            </Form>
          </div>
        )}
      </div>

      <Success_Modal
        show={showModal}
        successText="Coupon applied successfully"
        onHide={() => setShowModal(false)}
      />

      <View_All_Coupon_Code
        // onClick={handleSubmit(onSubmit)}
        onApply={(code) => {
          setValue("code", code); // set coupon in input
          handleSubmit(onSubmit)();
          setModalShow(false); // hit apply API
        }}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Product_Info;
